export default "__VITE_ASSET__6bVURrhE__"